import { render, staticRenderFns } from "./KgjtWebsiteNewsPic.vue?vue&type=template&id=dd69a7ae&scoped=true&"
import script from "./KgjtWebsiteNewsPic.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteNewsPic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd69a7ae",
  null
  
)

export default component.exports